import { Box, Grid, Typography } from "@mui/material";

const ReceiptorBankAccount = ({ bankAccount }) => {
    return (
      <Grid
        container
        margin={"24px 0px"}
        sx={{
          border: "1px solid grey",
          borderRadius: "8px",
          borderColor: "#E9EBF0",
        }}
      >
        <Grid
          item
          flexGrow={1}
          xs={6}
          sx={{
            borderRight: "1px solid grey",
            padding: "20px 0px",
            borderColor: "#E9EBF0",
          }}
        >
          <Typography
            sx={{
              ml: "8px",
              fontWeight: 400,
              fontSize: "16px",
              color: "#00010C",
            }}
            noWrap
          >
            {"Valor a ser creditado em"}
          </Typography>
        </Grid>
        <Grid
          container
          item
          sx={{
            padding: "20px 0px",
          }}
          flexGrow={1}
          xs={6}
        >
          <Grid item xs={6} display={"flex"} padding={"0px 12px"}>
            <Box display={"flex"} alignItems={"baseline"}>
              <img alt="logo" width={"32px"} src={bankAccount.logoUrl} />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: "8px",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#00010C",
                }}
                noWrap
              >
                {bankAccount.name}
              </Typography>
              <Typography
                sx={{
                  ml: "8px",
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#8087A6",
                }}
                noWrap
              >
                {bankAccount.code}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              Agência. {bankAccount.agency}
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              Conta. {bankAccount.accountNumber}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  export default ReceiptorBankAccount;